module.exports = __webpack_public_path__ + "static/alexPic-a1219d9b8b496671bc1c6e6c82a63885.jpg";